import type { ResidueGroup, WizardAnswers, WizardArchetype } from "../../types"

export const UFS = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG",
  "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"
] as const

// Conselho que assina, por arquétipo do beachhead
export const DEFAULT_COUNCIL: Record<string, string> = {
  odonto: "CRO",
  farmacia: "CRF",
  vet: "CRMV",
  laboratorio: "CRBM"
}

export const COUNCILS = ["CRO", "CRF", "CRMV", "CRBM"] as const

export const ARCHETYPE_ICONS: Record<string, string> = {
  odonto: "🦷",
  farmacia: "💊",
  vet: "🐾",
  laboratorio: "🔬"
}

// Grupos de resíduo da RDC 222 — cores dos "carimbos" no documento
export const GROUP_META: Record<ResidueGroup, { name: string, description: string, stamp: string }> = {
  A: { name: "Grupo A", description: "Biológicos / infectantes", stamp: "bg-rose-100 text-rose-800 border-rose-300" },
  B: { name: "Grupo B", description: "Químicos", stamp: "bg-amber-100 text-amber-800 border-amber-300" },
  C: { name: "Grupo C", description: "Radioativos", stamp: "bg-violet-100 text-violet-800 border-violet-300" },
  D: { name: "Grupo D", description: "Comuns (recicláveis e não recicláveis)", stamp: "bg-slate-100 text-slate-700 border-slate-300" },
  E: { name: "Grupo E", description: "Perfurocortantes", stamp: "bg-sky-100 text-sky-800 border-sky-300" }
}

export const GROUP_ORDER: ResidueGroup[] = ["A", "B", "C", "D", "E"]

// Espelho client-side da derivação (a autoritativa é server-side em
// Archetype#derive_residue_groups). Data-driven do mesmo jsonb de perguntas.
export function deriveResidueGroups(archetype: WizardArchetype | null, answers: WizardAnswers): ResidueGroup[] {
  const groups = new Set<ResidueGroup>(["D"])
  if (archetype) {
    for (const question of archetype.questions) {
      if (answers[question.key]) question.residue_groups.forEach(g => groups.add(g))
    }
  }
  return GROUP_ORDER.filter(g => groups.has(g))
}
